import React from "react";
// Homepage Demo

import HomeDark from "../views/All-home-version/HomeDark";

// Service
import Service from "../views/Inner-pages/service/Service";
import ServiceDetails from "../views/Inner-pages/service/ServiceDetails";

// About
import AboutUs from "../views/Inner-pages/about/AboutUs";
import AboutMe from "../views/Inner-pages/about/AboutMe";

// Blog
import BlogGrid from "../views/Inner-pages/blog/BlogGrid";
import BlogMasonry from "../views/Inner-pages/blog/BlogMasonry";
import BlogSidebar from "../views/Inner-pages/blog/BlogSidebar";
import BlogDetails from "../views/Inner-pages/blog/BlogDetails";
import BlogDetailsSidebar from "../views/Inner-pages/blog/BlogDetailsSidebar";

// Portfolio
import WorksGrid from "../views/Inner-pages/portfolio/WorksGrid";
import WorksMasonry from "../views/Inner-pages/portfolio/WorksMasonry";
import WorksListing from "../views/Inner-pages/portfolio/WorksListing";
import WorksCarousel from "../views/Inner-pages/portfolio/WorksCarousel";
import WorksShowcase from "../views/Inner-pages/portfolio/WorksShowcase";

// Others
import NotFound from "../views/NotFound";
import { HashRouter, Route, Routes } from "react-router-dom";
import ScrollTopBehaviour from "../components/ScrollTopBehaviour";
import Login from "../views/Inner-pages/auth/login/login";
import Register from "../views/Inner-pages/auth/register";

import NewTicket from "../views/Inner-pages/ticket/new-ticket/newTicket";
import Tickets from "../views/Inner-pages/ticket/tikets/tickets";
import TicketChat from "../views/Inner-pages/ticket/tikets/ticketChat";
import Contact from "../views/Inner-pages/Contact";

import Protected from "../layouts/Protected";
import GoshopsDemo from "../views/Inner-pages/service/Goshops-multi-shop";
import EnvatoAuth from "../views/Inner-pages/auth/envato";

// career page
import Career from "../views/Inner-pages/career/career";
import ForJobForm from "../views/Inner-pages/for_job_form";

// vendor doc
import VendorDocumentations from "../views/Vendor-documentations";
import VendorCustomizationMobile from "../views/Vendor-documentations/Customization-mobile";
import VendorAppBuildRelease from "../views/Vendor-documentations/App-build-release";
import VendorUpdateAppWeb from "../views/Vendor-documentations/Update-app-web";

import Activator from "../views/Inner-pages/activator";
import AllWebProduct from "../views/Inner-pages/service/AllWebProduct";
import AllAndroidProduct from "../views/Inner-pages/service/AllAndroidProduct";
import FoodymanSingle from "../views/Inner-pages/service/FoodymanSingleServise";
import FoodymanMulti from "../views/Inner-pages/service/FoodymanMultiServise";
import QrcodeMulti from "../views/Inner-pages/service/QrcodeMultiServise";
import GoshopsMultiShop from "../views/Inner-pages/service/Goshops-multi-shop";
import GoshopsMultiSeller from "../views/Inner-pages/service/Goshops-multi-seller";
import GoshopSingleShop from "../views/Inner-pages/service/Goshops-single-shop";
import SundaymartMultiVendor from "../views/Inner-pages/service/Sundaymart-multi-vendor";
import SundaymartMultiVendorNew from "../views/Inner-pages/service/Sundaymart-multi-vendor-new";
import UserProfile from "../components/User/User-profile";

// damda
import DamdaService from "../views/Inner-pages/service/Damda/DamdaService";
import DamdaLandlord from "../views/Inner-pages/service/Damda/DamdaLandlord";
import DamdaApp from "../views/Inner-pages/service/Damda/DamdaSayyoh";

import UzmartMultiServise from "../views/Inner-pages/service/UzmartMultiServise";
import MobileUiKitService from "../views/Inner-pages/service/Mobile-ui-kit-service";
import SaasMulti from "../views/Inner-pages/service/SaasMultiServise";
import Demand24MultiService from "../views/Inner-pages/service/Demand24MultiServise";

//Routes
import Goshops from "./Routing-goshops";
import Saas from "./Routing-saas";
import Sundaymart from "./Routing-sundaymart";
import Foodyman from "./Routing-foodyman";
import Uzmart from "./Routing-uzmart";
import Qrcode from "./Routing-qrcode";
import SingleFoodyman from "./Routing-single-foodyman";
import Gstore from "./Routing-gstore";
import Demand24 from "./Routing-demand24";
import SingleUzmart from "./Routing-single-uzmart";
import SingleUzmartMultiServise from "../views/Inner-pages/service/SingleUzmartMultiServise";
import NewGoShops from "./Routing-new-goshops";
import NewGoShopsMultiServise from "../views/Inner-pages/service/NewGoShopsMultiServise";
import Quick from "./Routing-quick";
import QuickApp from "../views/Inner-pages/service/Quick";
import Sundaymart_v2 from "./Routing-sundaymart_v2";
import Sundaymart_v2Service from "../views/Inner-pages/service/Sundaymart_v2Service";

const Routing = () => {
  return (
    <>
      <HashRouter>
        <ScrollTopBehaviour />
        <Routes>
          {Foodyman()}
          {Demand24()}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </HashRouter>
    </>
  );
};

export default Routing;
